<div class="d-flex flex-column flex-root min-vh-100">
    <div class="d-flex flex-column flex-center flex-column-fluid">
        <div class="d-flex flex-column flex-center text-center p-10">
            <div class="card card-flush w-lg-400px py-5">
                <div class="card-body py-15 py-lg-20">
                    <div class="mb-7">
                        <img alt="Logo" src="./assets/media/svg/brand-logos/Okta-word-logo2.svg" class="h-40px" />
                    </div>
                    <div class="mb-7">
                        <span class="spinner-border spinner-border-lg text-primary"></span>
                    </div>
                    <h1 class="fw-bolder text-gray-900 mb-5">Completing Sign-In</h1>
                    <div class="fw-semibold fs-6 text-gray-500 mb-7">
                        Please wait while we authenticate your account...
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>